export const GET_LEADS_CAP_BRANDS_REQUEST = 'GET_LEADS_CAP_BRANDS_REQUEST';
export const GET_LEADS_CAP_BRANDS_REQUEST_SUCCESS = 'GET_LEADS_CAP_BRANDS_REQUEST_SUCCESS';
export const GET_LEADS_CAP_BRANDS_REQUEST_FAILURE = 'GET_LEADS_CAP_BRANDS_REQUEST_FAILURE';

export const GET_LEADS_CAP_MODELS_REQUEST = 'GET_LEADS_CAP_MODELS_REQUEST';
export const GET_LEADS_CAP_MODELS_REQUEST_SUCCESS = 'GET_LEADS_CAP_MODELS_REQUEST_SUCCESS';
export const GET_LEADS_CAP_MODELS_REQUEST_FAILURE = 'GET_LEADS_CAP_MODELS_REQUEST_FAILURE';

export const GET_LEADS_CAP_VERSIONS_REQUEST = 'GET_LEADS_CAP_VERSIONS_REQUEST';
export const GET_LEADS_CAP_VERSIONS_REQUEST_SUCCESS = 'GET_LEADS_CAP_VERSIONS_REQUEST_SUCCESS';
export const GET_LEADS_CAP_VERSIONS_REQUEST_FAILURE = 'GET_LEADS_CAP_VERSIONS_REQUEST_FAILURE';

export const GET_LEADS_CAP_DERIVATIVES_REQUEST = 'GET_LEADS_CAP_DERIVATIVES_REQUEST';
export const GET_LEADS_CAP_DERIVATIVES_REQUEST_SUCCESS = 'GET_LEADS_CAP_DERIVATIVES_REQUEST_SUCCESS';
export const GET_LEADS_CAP_DERIVATIVES_REQUEST_FAILURE = 'GET_LEADS_CAP_DERIVATIVES_REQUEST_FAILURE';

export const GET_LEADS_CAP_REGISTRATION_REQUEST = 'GET_LEADS_CAP_REGISTRATION_REQUEST';
export const GET_LEADS_CAP_REGISTRATION_REQUEST_SUCCESS = 'GET_LEADS_CAP_REGISTRATION_REQUEST_SUCCESS';
export const GET_LEADS_CAP_REGISTRATION_REQUEST_FAILURE = 'GET_LEADS_CAP_REGISTRATION_REQUEST_FAILURE';

export const GET_LEADS_CAP_VALUATION_REQUEST = 'GET_LEADS_CAP_VALUATION_REQUEST';
export const GET_LEADS_CAP_VALUATION_REQUEST_SUCCESS = 'GET_LEADS_CAP_VALUATION_REQUEST_SUCCESS';
export const GET_LEADS_CAP_VALUATION_REQUEST_FAILURE = 'GET_LEADS_CAP_VALUATION_REQUEST_FAILURE';

export const GET_LEADS_ALL_VALUATIONS_REQUEST_SUCCESS = 'GET_LEADS_ALL_VALUATIONS_REQUEST_SUCCESS';
export const GET_LEADS_ALL_VALUATIONS_REQUEST_FAILURE = 'GET_LEADS_ALL_VALUATIONS_REQUEST_FAILURE';

export const GET_LEADS_EXISTING_STOCK_REQUEST_SUCCESS = 'GET_LEADS_EXISTING_STOCK_REQUEST_SUCCESS';

export const GET_LEADS_MOT_HISTORY_REQUEST = 'GET_LEADS_MOT_HISTORY_REQUEST';
export const GET_LEADS_MOT_HISTORY_REQUEST_SUCCESS = 'GET_LEADS_MOT_HISTORY_REQUEST_SUCCESS';
export const GET_LEADS_MOT_HISTORY_REQUEST_FAILURE = 'GET_LEADS_MOT_HISTORY_REQUEST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/constants/cap.constants.js